import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import useViews from '@/common/components/FilterViews/hooks/useViews/useViews'

const useNavigateToFilterView = ({ viewType, defaultViews, updateContext, storeId, route, filtersKey = 'filters' }) => {
  const navigation = useNavigate()
  const [view, setView] = useState(null)
  const { selectedView, setSelectedView } = useViews({
    storeId,
    defaultViews,
    type: viewType,
  })

  useEffect(() => {
    if (view && view?.id === selectedView?.id) {
      navigation(route)
    }
  }, [selectedView, viewType, navigation, view, route])

  const handleGoView = view => {
    updateContext(context => ({ ...context, [filtersKey]: view.filters }))
    setView(view)
    setSelectedView(view)
  }

  return {
    handleGoView,
  }
}

export default useNavigateToFilterView
